// Authority types configuration based on existing code in constants/index.js
export const AUTHORITY_TYPES = {
  PERSONAL_NAME: 'personalName',
  CORPORATE_NAME: 'corporateName',
  MEETING_NAME: 'meetingName',
  UNIFORM_TITLE: 'uniformTitle',
  SUBJECT: 'subject',
  ALL: 'all',
};

// Search dropdown values from existing getAuthorityTypeForField function
export const DROPDOWN_VALUES = {
  PERSONAL_NAME_TITLE: 'personalNameTitle',
  CORPORATE_NAME_TITLE: 'corporateNameTitle',
  UNIFORM_TITLE: 'uniformTitle',
  SUBJECT: 'subject',
  KEYWORD: 'keyword',
};

// Mapping from FOLIO API authority types to our constants
export const FOLIO_AUTHORITY_TYPE_MAPPING = {
  'Topical': AUTHORITY_TYPES.SUBJECT,
  'Personal Name': AUTHORITY_TYPES.PERSONAL_NAME,
  'Corporate Name': AUTHORITY_TYPES.CORPORATE_NAME,
  'Meeting Name': AUTHORITY_TYPES.MEETING_NAME,
  'Uniform Title': AUTHORITY_TYPES.UNIFORM_TITLE,
  'Geographic Name': 'geographicName',
  'Genre': 'genre',
};

// Field to authority type mapping from existing AUTHORITY_LINKED_FIELDS
export const FIELD_AUTHORITY_MAPPING = {
  'subjects.value': [AUTHORITY_TYPES.SUBJECT, 'Topical'],
  'series.value': [AUTHORITY_TYPES.UNIFORM_TITLE, 'Uniform Title'],
  'alternativeTitles.alternativeTitle': [AUTHORITY_TYPES.UNIFORM_TITLE, 'Uniform Title'],
  'contributors.name': [
    AUTHORITY_TYPES.PERSONAL_NAME,
    AUTHORITY_TYPES.CORPORATE_NAME,
    AUTHORITY_TYPES.MEETING_NAME,
    'Personal Name',
    'Corporate Name',
    'Meeting Name',
  ],
};

// Contributor name type mapping from existing getAuthorityTypeByContributorNameType
export const CONTRIBUTOR_NAME_TYPE_MAPPING = {
  'Personal name': AUTHORITY_TYPES.PERSONAL_NAME,
  'Corporate name': AUTHORITY_TYPES.CORPORATE_NAME,
  'Meeting name': AUTHORITY_TYPES.MEETING_NAME,
};
